import { Breadcrumb, Button, Col, Divider, Icon, Input, InputNumber, message, Modal, Row, Table } from "antd";
import Text from "antd/lib/typography/Text";
import React, { useState, useEffect, useRef } from "react";

import { useParams, Link } from "react-router-dom";

import {
    fetchUser,
    fetchVouchers,
    addVoucher,
    syncTransactionAPI,
    fetchTransaction,
    fetchAllStoresApi,
    unlockCard,
} from "utils/apiService";

import avatarLarge from "media/avatarLarge.svg";
import Loader from "components/Loader/Loader";
import CoinLogo from "./image/Icon_money.svg";
import CashLogo from "./image/Cash-Money-icon.svg";
import NoCard from "./image/21nocards.png";
import GreenCoin from "./image/Icon_moneygreen.svg";
import GreyCash from "./image/Cash-Moneygrey.svg";

const roundDecimalTo3 = (value) => {
    let x = Math.round(value * 1000) / 1000
    return x
}

const CardDetails = ({ userData }) => {
    let inaamcard = userData?.app_cards?.find((item) => {
        return item?.number === userData?.customer_data?.card_number;
    });

    let lsccard = userData?.lsc_cards?.find((item) => {
        return item?.number === userData?.customer_data?.card_number;
    });


    return (
        <>
            <div
                style={{
                    backgroundColor: "#f2f2f2",
                    padding: "16px",
                    width: "320px",
                    borderRadius: "10px",
                }}>
                <div
                    style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginBottom: "32px",
                    }}>
                    LSC
                </div>
                <div>
                    <div
                        style={{
                            fontWeight: "325",
                            color: "#747474",
                            fontSize: "16px",
                        }}>
                        Points
                    </div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                        }}>
                        <img
                            alt=''
                            style={{
                                display: "inline-block",
                                height: "20px",
                                width: "20px",
                                fontSize: "16px",
                                color: "rgba(255,255,255,0.8)",
                                margin: " 0 8px 5px 0",
                            }}
                            src={CoinLogo}
                        // theme={page === "cohorts" ? "filled" : "outlined"}
                        />
                        {roundDecimalTo3(lsccard?.points) || "0"}
                    </div>
                </div>
                <div style={{ paddingTop: "32px" }}>
                    <div style={{ fontWeight: "325", color: "#747474", fontSize: "16px" }}>Value</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                        }}>
                        <img
                            alt=''
                            style={{
                                display: "inline-block",
                                height: "20px",
                                width: "20px",
                                fontSize: "16px",
                                color: "rgba(255,255,255,0.8)",
                                margin: " 0 8px 5px 0",
                            }}
                            src={CashLogo}
                        // theme={page === "cohorts" ? "filled" : "outlined"}
                        />
                        {roundDecimalTo3(lsccard?.value) || "0"}
                    </div>
                </div>
            </div>
            <div
                style={{
                    backgroundColor: "#f2f2f2",
                    padding: "16px",
                    width: "320px",
                    borderRadius: "10px",
                    marginRight: "24px",
                }}>
                <div
                    style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        marginBottom: "32px",
                    }}>
                    Banat Al Nujoom APP
                </div>
                <div>
                    <div
                        style={{
                            fontWeight: "325",
                            color: "#747474",
                            fontSize: "17px",
                        }}>
                        Points
                    </div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                        }}>
                        <img
                            alt=''
                            style={{
                                display: "inline-block",
                                height: "20px",
                                width: "20px",

                                color: "rgba(255,255,255,0.8)",
                                margin: " 0 8px 5px 0",
                            }}
                            src={CoinLogo}
                        />
                        {/* {`${Math.round(inaamcard?.points * 10000) / 10000}` || "0"} */}
                        {roundDecimalTo3(inaamcard?.points) || "0"}
                        <span
                            style={{
                                display: inaamcard?.points === lsccard?.points ? "none" : "inline",
                                color: inaamcard?.points < lsccard?.points ? "#C91713" : "#fec708",
                                paddingLeft: "8px",
                                fontSize: "14px",
                            }}>
                            {Math.abs(lsccard?.points - inaamcard?.points) > 1 &&
                                <Icon
                                    style={{ paddingRight: "4px" }}
                                    type={inaamcard?.points < lsccard?.points ? "arrow-down" : "arrow-up"}
                                />
                            }
                            {Math.abs(lsccard?.points - inaamcard?.points) > 1 && roundDecimalTo3(Math.abs(lsccard?.points - inaamcard?.points))}
                        </span>
                    </div>
                </div>
                <div style={{ paddingTop: "32px" }}>
                    <div style={{ fontWeight: "325", color: "#747474", fontSize: "17px" }}>Value</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                        }}>
                        <img
                            alt=''
                            style={{
                                display: "inline-block",
                                height: "20px",
                                width: "20px",
                                color: "rgba(255,255,255,0.8)",
                                margin: " 0 8px 5px 0",
                            }}
                            src={CashLogo}
                        />
                        {roundDecimalTo3(inaamcard?.value) || "0"}
                        <span
                            style={{
                                display: inaamcard?.value === lsccard?.value ? "none" : "inline",
                                color: inaamcard?.value > lsccard?.value ? "#C91713" : "#fec708",
                                paddingLeft: "8px",
                                fontSize: "14px",
                            }}>
                            {Math.abs(lsccard?.value - inaamcard?.value) > 1 &&
                                <Icon
                                    style={{ paddingRight: "4px" }}
                                    type={inaamcard?.value < lsccard?.value ? "arrow-down" : "arrow-up"}
                                />
                            }
                            {Math.abs(lsccard?.value - inaamcard?.value) > 1 && roundDecimalTo3(Math.abs(lsccard?.value - inaamcard?.value))}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

const ViewCardsTable = ({ userData, FetchUserAPI }) => {
    return (
        <Row style={{ flexGrow: "1", display: "flex", flexDirection: "row" }}>
            <Col style={{ marginRight: "12px", color: "#000000", fontWeight: "bold", width: "100%" }}>
                <div style={{ margin: "16px 0px", fontSize: "16px" }}>In Banat Al Nujoom App</div>
                {userData.app_cards?.map((item, Index) => {
                    return (
                        <div
                            style={{
                                margin: "16px 0px",
                                padding: "16px",
                                fontSize: "14px",
                                border: "1px solid #e6e6e6",
                                borderRadius: "8px",
                            }}>
                            <div
                                style={{
                                    display: "flex",
                                    // cursor: "pointer",
                                }}
                            // onClick={() => {
                            //     setCard(item);
                            //     // setViewSingleCard(true);
                            // }}
                            >
                                <Col span={18}>
                                    <div style={{ marginBottom: "9px" }}>Card #{Index + 1}</div>
                                    <div>
                                        <Icon type='credit-card' style={{ marginRight: "4px" }} />
                                        {item?.number}
                                    </div>
                                </Col>
                                <Col span={6} style={{ right: "0px", alignSelf: "center", color: "#fec708" }}>
                                    <div>
                                        <img
                                            alt=''
                                            style={{
                                                display: "inline-block",
                                                height: "20px",
                                                width: "20px",
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                marginRight: "4px",
                                            }}
                                            src={CoinLogo}
                                        />
                                        {roundDecimalTo3(item?.points)}
                                    </div>
                                    <div style={{ color: "#747474" }}>
                                        <img
                                            alt=''
                                            style={{
                                                display: "inline-block",
                                                height: "20px",
                                                width: "20px",
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                marginRight: "4px",
                                            }}
                                            src={GreyCash}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        {roundDecimalTo3(item?.points)}
                                    </div>
                                </Col>
                            </div>
                            <div style={{ display: `${!item?.status ? "none" : "block"}` }}>
                                <Button
                                    style={{
                                        borderRadius: "4px",
                                        color: "#fec708",
                                        border: "1px solid #fec708",
                                        width: "100%",
                                        marginTop: "18px",
                                    }}
                                    onClick={() => {
                                        unlockCard({
                                            requestData: {
                                                card_number: item.number,
                                            },
                                            resErrorCallback: (res) => {
                                                if (res.status === 404 || res.data.status === 404)
                                                    message.error("Banat Al Nujoom card doesn't exist");
                                            },
                                            res200Callback: (res) => {
                                                FetchUserAPI();
                                                message.success("Banat Al Nujoom card is Unlocked...");
                                            },
                                        });
                                    }}>
                                    Unlock
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </Col>
            <Col style={{ marginLeft: "12px", color: "#000000", fontWeight: "bold", width: "100%" }}>
                <div style={{ margin: "16px 0px", fontSize: "16px" }}>In LSC App</div>
                {userData.lsc_cards?.map((item, Index) => {
                    return (
                        <div
                            style={{
                                margin: "16px 0px",
                                padding: "16px",
                                fontSize: "14px",
                                border: "1px solid #e6e6e6",
                                borderRadius: "8px",
                            }}>
                            <div
                                style={{
                                    display: "flex",
                                    // cursor: "pointer",
                                }}
                            // onClick={() => {
                            //     setCard(item);
                            //     // setViewSingleCard(true);
                            // }}
                            >
                                <Col span={18}>
                                    <div style={{ marginBottom: "9px" }}>Card #{Index + 1}</div>
                                    <div>
                                        <Icon type='credit-card' style={{ marginRight: "4px" }} />
                                        {item?.number}
                                    </div>
                                </Col>
                                <Col span={6} style={{ right: "0px", color: "#fec708", alignSelf: "center" }}>
                                    {/* <Button
                                        style={{
                                            borderRadius: "4px",
                                            color: "#fec708",
                                            border: "1px solid #fec708",
                                            visibility: `${!item?.status ? "hidden" : "visible"}`,
                                        }}
                                        onClick={() => {
                                            unlockCard({
                                                requestData: {
                                                    card_number: item.number,
                                                },
                                                resCallback: (res) => {
                                                    if (res.status === "404") message.error("Banat Al Nujoom card doesn't exist");
                                                },
                                                res200Callback: (res) => {
                                                    FetchUserAPI();
                                                    message.success("Banat Al Nujoom card is Unlock...");
                                                },
                                            });
                                        }}>
                                        Unlock
                                    </Button> */}
                                    <div>
                                        <img
                                            alt=''
                                            style={{
                                                display: "inline-block",
                                                height: "20px",
                                                width: "20px",
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                marginRight: "4px",
                                            }}
                                            src={CoinLogo}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        {roundDecimalTo3(item?.points)}
                                    </div>
                                    <div style={{ color: "#747474" }}>
                                        <img
                                            alt=''
                                            style={{
                                                display: "inline-block",
                                                height: "20px",
                                                width: "20px",
                                                fontSize: "16px",
                                                color: "rgba(255,255,255,0.8)",
                                                marginRight: "4px",
                                            }}
                                            src={GreyCash}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                        />
                                        {roundDecimalTo3(item?.points)}
                                    </div>
                                </Col>
                            </div>
                        </div>
                    );
                })}
            </Col>
            {/* <ViewCard viewSingleCard={viewSingleCard} setViewSingleCard={setViewSingleCard} card={card} /> */}
        </Row>
    );
};
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const Dateformatter = (timestamp) => {
    var datetime = new Date(timestamp);
    var date = datetime.getDate();
    var month = months[datetime.getMonth()];
    var year = datetime.getFullYear();

    return date + " " + month + ", " + year;
};

const SyncTransactionTable = ({ userData, searchKey, storeList }) => {
    const getAddress = (storeId) => {
        var storedata = storeList?.find((store) => store?.company_code === storeId);
        return (
            storedata?.location?.address +
            " ," +
            (storedata?.location?.city || storedata?.location?.region) +
            " ," +
            storedata?.location?.country
        );
    };
    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    }
    function SortTransactionbyDate(prop) {
        return function (a, b) {
            let a1 = new Date(a[prop]);
            let b1 = new Date(b[prop]);
            if (a1 > b1) {
                return 1;
            } else if (a1 < b1) {
                return -1;
            }
            return 0;
        };
    }
    return (
        <Row
            style={{
                flexGrow: "1",
                maxHeight: "430px",
                overflowY: "auto",
                justifyContent: "space-between",
                display: "flex",
            }}>
            <Col span={11} style={{ marginRight: "12px", color: "#000000", fontWeight: "bold" }}>
                <div style={{ margin: "16px 0px", fontSize: "16px" }}>In Banat Al Nujoom App</div>
                {userData.app_transactions
                    ?.filter((item) => {
                        return searchKey.length > 0
                            ? item?.transaction_number.toLowerCase().includes(searchKey.toLowerCase())
                            : true;
                    })
                    ?.sort(GetSortOrder("transaction_number"))
                    // ?.sort(SortTransactionbyDate("timestamp"))
                    ?.map((item) => {
                        return (
                            <div
                                style={{
                                    margin: "16px 0px",
                                    padding: "16px",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    border: "1px solid #e6e6e6",
                                }}>
                                <div style={{ display: "flex" }}>
                                    <Col span={16}>
                                        {/* <div>{`${new Date(item?.date)?.getDate()}/${new Date(item?.date)?.getMonth()}/${new Date(item?.date)?.getFullYear()}`}</div> */}
                                        <div>{Dateformatter(item?.timestamp)}</div>
                                        <div style={{ fontSize: "12px", color: "#747474" }}>
                                            ID: {item?.transaction_number?.split("-")[0]}
                                        </div>
                                    </Col>
                                    <Col
                                        span={8}
                                        style={{
                                            textAlign: "right",
                                            fontSize: "16px",
                                            color: item.points > 0 ? "#fec708" : "#C91713",
                                        }}>
                                        {item?.points > 0 ? "+ " + item?.points : item?.points}
                                    </Col>
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    <Divider style={{ margin: "8px 0px" }} />
                                    {storeList?.findIndex((store) => store?.company_code === item?.store_id) >= 0 ? (
                                        <>
                                            <div>
                                                {
                                                    storeList?.find((store) => store?.company_code === item?.store_id)
                                                        ?.name
                                                }
                                            </div>
                                            <div style={{ color: "#A3A3A3", fontSize: "12px" }}>
                                                {getAddress(item?.store_id) || ""}
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>
                                            Transaction made through Banat Al Nujoom App
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                {userData.app_transactions?.filter((item) => {
                    return searchKey.length > 0
                        ? item?.transaction_number.toLowerCase().includes(searchKey.toLowerCase())
                        : true;
                })?.length <= 0 ? (
                    <div
                        style={{
                            margin: "16px 0px",
                            padding: "16px",
                            fontSize: "14px",
                            border: "1px solid #e6e6e6",
                            color: "#595959",
                            textAlign: "center",
                        }}>
                        No Transaction
                    </div>
                ) : (
                    ""
                )}
            </Col>
            <Col span={11} style={{ marginLeft: "12px", color: "#000000", fontWeight: "bold" }}>
                <div style={{ margin: "16px 0px", fontSize: "16px" }}>In LSC App</div>
                {userData.lsc_transactions
                    ?.filter((item) => {
                        return searchKey?.length > 0
                            ? item?.transaction_number.toLowerCase().includes(searchKey.toLowerCase())
                            : true;
                    })
                    ?.sort(GetSortOrder("transaction_number"))
                    // ?.sort(SortTransactionbyDate("date"))
                    ?.map((item) => {
                        return (
                            <div
                                style={{
                                    margin: "16px 0px",
                                    padding: "16px",
                                    fontSize: "14px",
                                    borderRadius: "8px",
                                    border: "1px solid #e6e6e6",
                                }}>
                                <div style={{ display: "flex" }}>
                                    <Col span={16}>
                                        <div>{Dateformatter(item?.date)}</div>
                                        <div style={{ fontSize: "12px", color: "#747474" }}>
                                            ID: {item?.transaction_number.split("-")[0]}
                                        </div>
                                    </Col>
                                    <Col
                                        span={8}
                                        style={{
                                            textAlign: "right",
                                            color: item?.points > 0 ? "#fec708" : "#C91713",
                                            fontSize: "16px",
                                        }}>
                                        {item?.points > 0 ? "+ " + item?.points : item?.points}
                                    </Col>
                                </div>
                                <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                                    <Divider style={{ margin: "8px 0px" }} />
                                    {storeList?.findIndex((store) => store?.company_code === item?.store_id) >= 0 ? (
                                        <>
                                            <div>
                                                {
                                                    storeList?.find((store) => store?.company_code === item?.store_id)
                                                        ?.name
                                                }
                                            </div>
                                            <div style={{ color: "#A3A3A3", fontSize: "12px" }}>
                                                {getAddress(item?.store_id) || ""}
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ color: "#A3A3A3", fontSize: "12px" }}>
                                            Transaction made through Banat Al Nujoom App
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                {userData.lsc_transactions?.filter((item) => {
                    return searchKey.length > 0
                        ? item?.transaction_number.toLowerCase().includes(searchKey.toLowerCase())
                        : true;
                })?.length <= 0 ? (
                    <div
                        style={{
                            margin: "16px 0px",
                            padding: "16px",
                            fontSize: "14px",
                            border: "1px solid #e6e6e6",
                            color: "#595959",
                            textAlign: "center",
                        }}>
                        No Transaction
                    </div>
                ) : (
                    ""
                )}
            </Col>
        </Row>
    );
};
const SyncVoucherTable = ({ userData, searchKey }) => {
    return (
        <Row
            style={{
                flexGrow: "1",
                maxHeight: "430px",
                margin: "16px 0px 0px 0px",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "8px",
                marginRight: "-8px",
            }}>
            <Col span={24} style={{ color: "#000000", fontSize: "12px" }}>
                <div style={{ fontWeight: "bold", margin: "0px 0px 16px 0px", fontSize: "16px" }}>In Banat Al Nujoom App</div>
                {userData?.voucher_wallet_list
                    ?.filter((item) => {
                        return searchKey.length > 0
                            ? item?.voucher_code.toLowerCase().includes(searchKey.toLowerCase())
                            : true;
                    })
                    ?.map((item, Index) => {
                        return (
                            <div
                                style={{
                                    margin: "16px 0px",
                                    padding: "16px",
                                    display: "flex",
                                    border: "1px solid #e6e6e6",
                                    borderRadius: "8px",
                                    fontSize: "16px",
                                }}>
                                {/* twoToneColor="#fec708" */}
                                <Col span={16}>
                                    <div>
                                        Voucher #{Index + 1}{" "}
                                        {item.status === "generated" ? (
                                            <Icon type='check-circle' theme='twoTone' />
                                        ) : item.status === "pending" ? (
                                            <Icon type='clock-circle' twoToneColor='#FAAD14' theme='twoTone' />
                                        ) : (
                                            <Icon type='close-circle' twoToneColor='#C91713' theme='twoTone' />
                                        )}
                                    </div>
                                    <div style={{ fontWeight: "bold" }}>{item?.voucher_code}</div>
                                    <div style={{ color: "#747474", fontSize: "14px" }}>
                                        <Icon type='calendar' /> {item?.date_modified}
                                        <span
                                            style={{ marginLeft: "12px", display: item?.is_used ? "inline" : "none" }}>
                                            <Icon type='barcode' /> {item?.date_redemption}
                                        </span>
                                    </div>
                                </Col>
                                <Col
                                    span={8}
                                    style={{
                                        textAlign: "right",
                                        color: "#fec708",
                                        fontSize: "16px",
                                        alignSelf: "center",
                                    }}>
                                    {/* <img
                                        alt=''
                                        style={{
                                            display: "inline-block",
                                            height: "20px",
                                            width: "20px",
                                            fontSize: "16px",
                                            color: "#fec708",
                                            margin: " 0 8px 5px 0",
                                        }}
                                        src={CoinLogo}
                                        // theme={page === "cohorts" ? "filled" : "outlined"}
                                    /> */}
                                    <img
                                        alt=''
                                        style={{
                                            display: "inline-block",
                                            height: "20px",
                                            width: "20px",
                                            fontSize: "16px",
                                            color: "rgba(255,255,255,0.8)",
                                            marginRight: "4px",
                                        }}
                                        src={CoinLogo}
                                    // theme={page === "cohorts" ? "filled" : "outlined"}
                                    />
                                    {item?.cost || "0"}
                                </Col>
                            </div>
                        );
                    })}

                {userData.voucher_wallet_list?.filter((item) => {
                    return searchKey.length > 0 ? item?.voucher_code.includes(searchKey) : true;
                })?.length <= 0 ? (
                    <div
                        style={{
                            margin: "16px 0px",
                            padding: "16px",
                            fontSize: "14px",
                            border: "1px solid #e6e6e6",
                            color: "#595959",
                            textAlign: "center",
                        }}>
                        No Voucher
                    </div>
                ) : (
                    ""
                )}
            </Col>
        </Row>
    );
};

const CustomerDetail = ({ ...props }) => {
    // Flag
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(true);
    const [viewCard, setViewCard] = useState(false);
    const [syncTransaction, setSyncTransaction] = useState(false);
    const [syncVoucher, setSyncVoucher] = useState(false);
    const [addMissingVoucher, setAddMissingVoucher] = useState(false);
    const [missingSync, setMissingSync] = useState(false);
    const [syncNotAggre, setSyncNotAggre] = useState(false);
    const [syncing, setSyncing] = useState(false);

    // Data

    const [userData, setUserData] = useState(null);
    const [transactionList, setTransactionList] = useState(null);
    const [voucherList, setVoucherList] = useState(null);
    const [searchKey, setSearchKey] = useState("");
    const [storeList, setStoreList] = useState(null);
    const [voucherCode, setVoucherCode] = useState("");

    // const [userData, setUserData] = useState(
    //     JSON.parse(
    //         `{ "app_cards": [ { "number": "string", "points": 0 ,"value": 0 } ], "lsc_cards": [ { "number": "string", "points": "number", "value": "number" } ], "customer_data": { "username": "string", "contact_number": "1234567890", "country_code": "string", "name": "Tejas Chauhan", "card_number": "1234567890", "date_of_birth": "datetime", "email": "string", "gender": "string", "nationality": "string", "emirate": "string" } }`
    //     )
    // );
    // const [transactionList, setTransactionList] = useState(
    //     JSON.parse(
    //         `{"status":200,"lsc_transactions":[{"transaction_number":"2CABDF49260F","points":-10000,"store_id":"8810","type":"sales","date":"02/26/22"},{"transaction_number":"8A3B87911C5B","points":1000.0,"store_id":"8888","type":"sales","date":"02/28/22"}],"app_transactions":[{"transaction_number":"2CABDF49260F-144454","timestamp":"26 Feb, 2022","points":10000.0,"store_id":"8055","type":"sales"},{"transaction_number":"8A3B87911C5B-144454","timestamp":"28 Feb, 2022","points":1000.0,"store_id":"8075","type":"sales"}]}`
    //     )
    // );
    // const [voucherList, setVoucherList] = useState(
    //     JSON.parse(
    //         `{"voucher_wallet_list":[{"voucher_code":"string","status":"string","barcode":{"uuid":"string","url":"string","url_original":"string"},"date_created":"datetime","date_modified":"datetime","date_redemption":"datetime","user":{"username":"string","contact_number":"string","country_code":"string","name":"string","card_number":"string","date_of_birth":"datetime","email":"string","gender":"string","nationality":"string","emirate":"string"}},{"voucher_code":"string","status":"string","barcode":{"uuid":"string","url":"string","url_original":"string"},"date_created":"datetime","date_modified":"datetime","date_redemption":"datetime","user":{"username":"string","contact_number":"string","country_code":"string","name":"string","card_number":"string","date_of_birth":"datetime","email":"string","gender":"string","nationality":"string","emirate":"string"}},{"voucher_code":"string","status":"string","barcode":{"uuid":"string","url":"string","url_original":"string"},"date_created":"datetime","date_modified":"datetime","date_redemption":"datetime","user":{"username":"string","contact_number":"string","country_code":"string","name":"string","card_number":"string","date_of_birth":"datetime","email":"string","gender":"string","nationality":"string","emirate":"string"}},{"voucher_code":"string","status":"generated","barcode":{"uuid":"string","url":"string","url_original":"string"},"date_created":"datetime","date_modified":"datetime","date_redemption":"datetime","user":{"username":"string","contact_number":"string","country_code":"string","name":"string","card_number":"string","date_of_birth":"datetime","email":"string","gender":"string","nationality":"string","emirate":"string"}},{"voucher_code":"string","status":"pending","barcode":{"uuid":"string","url":"string","url_original":"string"},"date_created":"datetime","date_modified":"datetime","date_redemption":"datetime","user":{"username":"string","contact_number":"string","country_code":"string","name":"string","card_number":"string","date_of_birth":"datetime","email":"string","gender":"string","nationality":"string","emirate":"string"}}]}`
    //     )
    // );
    // const [searchKey, setSearchKey] = useState("");
    // const [storeList, setStoreList] = useState(null);
    // const [voucherCode, setVoucherCode] = useState("");

    const { userType, country_code, customerID } = useParams();

    useEffect(() => {
        setLoading(true);
        // setLoading(false);
        FetchUserAPI();
        loadStores();
    }, []);

    const FetchUserAPI = () => {
        fetchUser({
            requestData: {
                country_code: country_code,
                contact_number: customerID.replace(country_code, ""),
            },
            res200Callback: (res) => {
                setUserData(res.data);
                setLoading(false);
            },
        });
    };

    const FetchTransactionAPI = () => {
        setActionLoading(true);

        // setActionLoading(false);
        // setMissingSync(!Comparetransaction(transactionList));

        fetchTransaction({
            requestData: {
                reward_card_number: userData.customer_data.card_number,
            },
            res200Callback: (res) => {
                setTransactionList(res.data);
                setMissingSync(Comparetransaction(res.data));
                setSyncNotAggre(checkSyncButNotAggre(res.data));
                if (res.data.lsc_transactions.length > 0 || res.data.app_transactions.length > 0)
                    setActionLoading(false);
            },
        });
    };

    const checkSyncButNotAggre = (data) => {
        const appTranscTotal = data.app_transactions.reduce((a, b) => a + b.points, 0);
        const lscTrancTotal = data.lsc_transactions.reduce((a, b) => a + b.points, 0);
        console.log(`agreeg check`,appTranscTotal,lscTrancTotal, data.lsc_transactions, Math.abs(appTranscTotal - lscTrancTotal));
        if (Math.abs(appTranscTotal - lscTrancTotal) < 1)
            return false
        else return true
    }

    const Comparetransaction = (data) => {

        const lsc = data.lsc_transactions.map((item) => {
            return {
                transaction_number: item?.transaction_number?.split("-")[0],
                points: Math.trunc(item.points),
                // store_id: item.store_id,
            };
        });
        const app = data.app_transactions.map((item) => {
            return {
                transaction_number: item?.transaction_number?.split("-")[0],
                points: Math.trunc(item.points),
                // store_id: item.store_id,
            };
        });
        console.log(`here`,data.lsc_transactions,data.lsc_transactions);
        const sync = true;
        if(data.lsc_transactions.length !== data.app_transactions.length){
            return false;
        }else
        return true
        // function GetSortOrder(prop) {
        //     return function (a, b) {
        //         if (a[prop] > b[prop]) {
        //             return 1;
        //         } else if (a[prop] < b[prop]) {
        //             return -1;
        //         }
        //         return 0;
        //     };
        // }
        // return (
        //     JSON.stringify(app.sort(GetSortOrder("transaction_number"))) === JSON.stringify(lsc.sort(GetSortOrder("transaction_number")))
        // );
    };

    const FetchVoucherAPI = () => {
        setActionLoading(true);
        // setActionLoading(false);
        fetchVouchers({
            requestData: {
                country_code: country_code,
                contact_number: customerID.replace(country_code, ""),
            },
            res200Callback: (res) => {
                setVoucherList(res.data);
                if (res.data.voucher_wallet_list.length > 0) setActionLoading(false);
            },
        });
    };

    const loadStores = () => {
        fetchAllStoresApi({
            requestData: {},
            res200Callback: (res) => {
                setStoreList(res.data.store_list);
            },
        });
    };

    return loading ? (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FAFAFA",
            }}>
            <Loader />
        </div>
    ) : (
        <Row>
            <Text
                style={{
                    color: "#181818",
                    /*fontFamily: "Gotham",*/ fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "24px",
                    lineHeight: "39px",
                }}>
                <Icon
                    type='arrow-left'
                    style={{
                        height: "16px",
                        paddingRight: "16px",
                    }}
                    onClick={() => props.history.go(-1)}
                />
                Customer Details
            </Text>
            <Breadcrumb style={{ margin: "4px 0" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
                <Breadcrumb.Item
                    style={{
                        /*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#747474",
                    }}>
                    <Link to={"/helpdesk"}>Search Customer</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item
                    style={{
                        /*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#464646",
                    }}>
                    Customer Details
                </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ margin: "8px 0px", width: "1px" }} />
            <Row
                type='flex'
                style={{
                    flexWrap: "nowrap",
                    border: "0px solid #F2F2F2",
                    boxSizing: "border-box",
                    marginTop: "24px",
                }}>
                <Row style={{ width: "25%" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={avatarLarge}
                            style={{
                                width: "80px",
                                height: "80px",
                            }}
                            alt={"Illustration"}
                        />
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                margin: "0 20px",
                            }}>
                            <Text
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    lineHeight: "32px",
                                    color: "#181818",
                                }}>
                                {userData?.customer_data?.name || "UNKNOWN"}
                            </Text>
                            <Text
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "18px",
                                    lineHeight: "24px",
                                }}>
                                <Icon type='phone' style={{ marginRight: "10.63px" }} />
                                {userData?.customer_data?.contact_number
                                    ? `${userData?.customer_data?.contact_number}`
                                    : "  -  "}
                            </Text>
                            <Text
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "18px",
                                    lineHeight: "24px",
                                }}>
                                <Icon type='credit-card' style={{ marginRight: "10.63px" }} />
                                {userData?.customer_data?.card_number
                                    ? `${userData?.customer_data?.card_number}`
                                    : "  -  "}
                            </Text>
                        </div>
                    </div>
                    {/* <div
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "18px",
                            lineHeight: "24px",
                        }}>
                        <div>
                            <Icon type='calendar' /> Date of Birth
                        </div>
                        <div>{userData?.customer_data.date_of_birth}</div>
                    </div>
                    <div
                        style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "18px",
                            lineHeight: "24px",
                        }}>
                        <div>
                            <Icon type='mail' /> Email Address
                        </div>
                        <div>{userData?.customer_data.email}</div>
                    </div> */}
                </Row>
                {/* <Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "20px", lineHeight: "32px", color: "#181818" }}>
						Customer Inaam Cards
					</Text> */}
                <Row style={{ width: "75%", display: "flex", flexDirection: "row-reverse" }}>
                    <CardDetails userData={userData} />
                </Row>
            </Row>
            <Divider style={{ margin: "16px 0px", width: "1px" }} />
            <Row>
                <Row
                    style={{
                        flexGrow: 1,
                    }}>
                    <Col span={12}>
                        <div
                            style={{
                                marginRight: "8px",
                                borderRadius: "10px",
                                backgroundColor: "#ffffff",
                                boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
                                padding: "16px",
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                height: "200px",
                            }}>
                            <div>
                                <div
                                    style={{
                                        color: "#181818",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginBottom: "16px",
                                        lineHeight: "24px",
                                    }}>
                                    <Icon type='credit-card' style={{ marginRight: "9.5px" }} />
                                    View Cards
                                </div>
                                {/* <div style={{ color: "#747474", marginBottom: "62px" }}> */}
                                <div style={{ color: "#747474" }}>
                                    Find all of the user’s cards in the Banat Al Nujoom & other system.
                                </div>
                            </div>
                            <div>
                                <Button
                                    size='large'
                                    style={{
                                        backgroundColor: "#fec708",
                                        color: "#ffffff",
                                    }}
                                    onClick={() => {
                                        setSearchKey("");
                                        setViewCard(true);
                                    }}>
                                    View Cards
                                </Button>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div
                            style={{
                                marginLeft: "8px",
                                borderRadius: "10px",
                                backgroundColor: "#ffffff",
                                boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
                                padding: "16px",
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                height: "200px",
                            }}>
                            <div>
                                <div
                                    style={{
                                        color: "#181818",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginBottom: "16px",
                                        lineHeight: "24px",
                                    }}>
                                    <Icon type='sync' style={{ marginRight: "9.5px" }} />
                                    Sync Transactions
                                </div>
                                {/* <div style={{ color: "#747474", marginBottom: "62px" }}> */}
                                <div style={{ color: "#747474" }}>
                                    Synchronise, View, & Manage Transactions in the Banat Al Nujoom & other systems
                                </div>
                            </div>
                            <div>
                                <Button
                                    size='large'
                                    style={{
                                        backgroundColor: "#fec708",
                                        color: "#ffffff",
                                    }}
                                    onClick={() => {
                                        FetchTransactionAPI();
                                        setSearchKey("");
                                        setSyncTransaction(true);
                                    }}>
                                    View Transactions
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row
                    style={{
                        flexGrow: 1,
                        marginTop: "16px",
                    }}>
                    <Col span={12}>
                        <div
                            style={{
                                marginRight: "8px",
                                borderRadius: "10px",
                                backgroundColor: "#ffffff",
                                boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
                                padding: "16px",
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                height: "200px",
                            }}>
                            <div>
                                <div
                                    style={{
                                        color: "#181818",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginBottom: "16px",
                                        lineHeight: "24px",
                                    }}>
                                    <Icon type='gift' style={{ marginRight: "9.5px" }} />
                                    View Vouchers
                                </div>
                                {/* <div style={{ color: "#747474", marginBottom: "62px" }}> */}
                                <div style={{ color: "#747474" }}>View Vouchers in the Banat Al Nujoom & other systems</div>
                            </div>
                            <div>
                                <Button
                                    size='large'
                                    style={{
                                        backgroundColor: "#fec708",
                                        color: "#ffffff",
                                    }}
                                    onClick={() => {
                                        setSearchKey("");
                                        FetchVoucherAPI();
                                        setSyncVoucher(true);
                                    }}>
                                    View Vouchers
                                </Button>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div
                            style={{
                                marginLeft: "8px",
                                borderRadius: "10px",
                                backgroundColor: "#ffffff",
                                boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
                                padding: "16px",
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                height: "200px",
                            }}>
                            <div>
                                <div
                                    style={{
                                        color: "#181818",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginBottom: "16px",
                                        lineHeight: "24px",
                                    }}>
                                    <Icon type='plus' style={{ marginRight: "9.5px" }} />
                                    Add missing vouchers
                                </div>
                                {/* <div style={{ color: "#747474", marginBottom: "62px" }}> */}
                                <div style={{ color: "#747474" }}>
                                    Add new missing vouchers in Banat Al Nujoom & other systems
                                </div>
                            </div>
                            <div>
                                <Button
                                    size='large'
                                    style={{
                                        backgroundColor: "#fec708",
                                        color: "#ffffff",
                                    }}
                                    onClick={() => {
                                        setSearchKey("");
                                        setAddMissingVoucher(true);
                                    }}>
                                    Add Vouchers
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Row>
            <Modal
                centered
                visible={viewCard}
                destroyOnClose
                width={850}
                maskClosable={false}
                onCancel={() => {
                    setViewCard(false);
                }}
                style={{
                    padding: "24px",
                }}
                title={
                    <span
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "#000000",
                            marginRight: "16px",
                        }}>
                        View Cards
                    </span>
                }
                footer={null}>
                {
                    <Row>
                        <div style={{ margin: "16px 0px" }}>
                            <ViewCardsTable userData={userData} FetchUserAPI={FetchUserAPI} />
                        </div>
                    </Row>
                }
            </Modal>
            <Modal
                centered
                visible={syncTransaction}
                destroyOnClose
                width={800}
                maskClosable={false}
                onCancel={() => {
                    setSyncTransaction(false);
                    setSyncing(false);
                }}
                style={{
                    padding: "24px",
                }}
                title={
                    <span
                        style={{
                            fontsize: "24px",
                            fontWeight: "bold",
                            color: "#000000",
                            marginRight: "16px",
                        }}>
                        Sync Transactions
                    </span>
                }
                footer={
                    !missingSync ? (
                        <Button
                            type='primary'
                            style={{
                                backgroundColor: "#fec708",
                                fontSize: "16px",
                                borderRadius: "4px",
                                color: "#ffffff",
                                border: "0px",
                            }}
                            disabled={missingSync}
                            loading={syncing}
                            onClick={() => {
                                setSyncing(true);
                                syncTransactionAPI({
                                    requestData: {
                                        card_number: userData.customer_data.card_number,
                                    },
                                    resCallback: () => {
                                        setSyncing(false);
                                    },
                                    res200Callback: (res) => {
                                        message.success("Transaction are synced successfully ");
                                        setSyncTransaction(false);
                                    },
                                });
                                setSyncTransaction(false);
                            }}>
                            {" "}
                            Synchronise Transactions
                        </Button>
                    ) : (
                        <Button
                            type='primary'
                            disabled
                            style={{
                                backgroundColor: "#f5f5f5",
                                fontSize: "16px",
                                borderRadius: "4px",
                                border: "1px solid #D9D9D9",
                            }}>
                            Synchronise Transactions
                        </Button>
                    )
                }>
                {actionLoading ? (
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                                src={NoCard}
                                style={{
                                    height: "80px",
                                    width: "120px",
                                }}></img>
                            <Text style={{ color: "#6E7191" }}>There are no cards linked to this account</Text>
                        </div>
                    </Row>
                ) : (
                    <Row>
                        <div>
                            <Input
                                style={{
                                    marginRight: "8px",
                                    width: "100%",
                                    // border: "1px solid rgb(0, 0, 0, 0.25)",
                                    // borderRadius: "5px",
                                    alignItems: "left",
                                }}
                                placeholder='Search by Transaction Id'
                                onChange={(e) => {
                                    setSearchKey(e.target.value);
                                }}
                                suffix={<Icon type='search' />}
                            // bordered={true}
                            />
                        </div>
                        {missingSync ? (
                            syncNotAggre ? (
                                <div
                                    style={{
                                        margin: "16px 0px",
                                        borderRadius: "8px",
                                        backgroundColor: "#fece081a",
                                        padding: "8px 16px",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}>
                                    <div style={{ alignSelf: "center", marginRight: "8px" }}>
                                        <Icon
                                            type='check-circle'
                                            theme='filled'
                                            style={{ fontSize: "24px", color: "#fec708" }}
                                        />
                                    </div>
                                    <div>
                                        <div style={{ color: "#fec708", fontWeight: "bold" }}>Transactions are synced but Points are not aggregated</div>
                                        <div style={{ color: "#747474", fontSize: "12px" }}>
                                            Please contact Application team to update the aggregated point
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        margin: "16px 0px",
                                        borderRadius: "8px",
                                        backgroundColor: "#EAF4EC",
                                        padding: "8px 16px",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}>
                                    <div style={{ alignSelf: "center", marginRight: "8px" }}>
                                        <Icon
                                            type='check-circle'
                                            theme='filled'
                                            style={{ fontSize: "24px", color: "#2D9140" }}
                                        />
                                    </div>
                                    <div>
                                        <div style={{ color: "#2D9140", fontWeight: "bold" }}>Transactions are synced</div>
                                        <div style={{ color: "#747474", fontSize: "12px" }}>
                                            The Transactions for Banat Al Nujoom App and LSC are already synced and updated
                                        </div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div
                                style={{
                                    margin: "16px 0px",
                                    borderRadius: "8px",
                                    backgroundColor: "#FFF2F1",
                                    padding: "8px 16px",
                                    display: "flex",
                                    flexDirection: "row",
                                }}>
                                <div style={{ alignSelf: "center", marginRight: "8px" }}>
                                    <Icon
                                        type='exclamation-circle'
                                        theme='filled'
                                        style={{ fontSize: "24px", color: "#C91713" }}
                                    />
                                </div>
                                <div>
                                    <div style={{ color: "#C91713", fontWeight: "bold" }}>
                                        Transactions are not synced
                                    </div>
                                    <div style={{ color: "#747474", fontSize: "12px" }}>
                                        Transactions are not matching in Banat Al Nujoom and LSC. Please Synchronise the
                                        transactions.
                                    </div>
                                </div>
                            </div>
                        )}
                        <div>
                            <SyncTransactionTable
                                userData={transactionList}
                                searchKey={searchKey}
                                storeList={storeList}
                            />
                        </div>
                    </Row>
                )}
            </Modal>
            <Modal
                centered
                visible={syncVoucher}
                destroyOnClose
                width={600}
                maskClosable={false}
                onCancel={() => {
                    setSyncVoucher(false);
                }}
                style={{
                    padding: "24px",
                }}
                title={
                    <>
                        <span
                            style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "#000000",
                                marginRight: "16px",
                            }}>
                            View Vouchers
                        </span>
                    </>
                }
                footer={
                    null
                    // <button
                    //     style={{
                    //         backgroundColor: "#fec708",
                    //         fontSize: "16px",
                    //         borderRadius: "4px",
                    //         color: "#ffffff",
                    //         border: "0px",
                    //         padding: "8px 16px",
                    //     }}>
                    //     {" "}
                    //     Cancel
                    // </button>
                }>
                {actionLoading ? (
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img
                                src={NoCard}
                                style={{
                                    height: "80px",
                                    width: "120px",
                                }}></img>
                            <Text style={{ color: "#6E7191" }}>There are no Voucher generated to this account</Text>
                        </div>
                    </Row>
                ) : (
                    <Row>
                        <div>
                            <Input
                                style={{
                                    marginRight: "8px",
                                    width: "100%",
                                    // border: "1px solid rgb(0, 0, 0, 0.25)",
                                    // borderRadius: "5px",
                                    alignItems: "left",
                                }}
                                placeholder='Search by Voucher Id'
                                onChange={(e) => {
                                    setSearchKey(e.target.value);
                                }}
                                suffix={<Icon type='search' />}
                            // bordered={true}
                            />
                        </div>
                        <div>
                            <SyncVoucherTable userData={voucherList} searchKey={searchKey} />
                        </div>
                    </Row>
                )}
            </Modal>
            <Modal
                centered
                visible={addMissingVoucher}
                destroyOnClose
                width={800}
                maskClosable={false}
                onCancel={() => {
                    setAddMissingVoucher(false);
                }}
                style={{
                    padding: "24px",
                }}
                bodyStyle={{
                    height: "310px",
                }}
                footer={
                    voucherCode.length === 12 ? (
                        <Button
                            style={{
                                backgroundColor: "#fec708",
                                fontSize: "16px",
                                borderRadius: "4px",
                                color: "#ffffff",
                                border: "0px",
                            }}
                            onClick={() => {
                                if (voucherCode.length === 12) {
                                    addVoucher({
                                        requestData: {
                                            voucher_code: voucherCode,
                                            country_code: country_code,
                                            contact_number: customerID.replace(country_code, ""),
                                        },
                                        res200Callback: () => {
                                            setAddMissingVoucher(false);
                                        },
                                    });
                                } else {
                                    message.error("Please enter valid Voucher Code");
                                }
                            }}>
                            {" "}
                            Add Voucher
                        </Button>
                    ) : (
                        <Button
                            type='primary'
                            disabled
                            style={{
                                backgroundColor: "#f5f5f5",
                                fontSize: "16px",
                                borderRadius: "4px",
                                border: "1px solid #D9D9D9",
                            }}>
                            Add Voucher
                        </Button>
                    )
                }>
                {
                    <Row>
                        <div
                            style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "#000000",
                                marginRight: "16px",
                            }}>
                            Add Missing Voucher
                        </div>
                        <Divider style={{ margin: "16px 0px" }} />
                        <div>
                            <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#000000" }}>Voucher ID</div>
                            <Input
                                style={{
                                    width: "100%",
                                    border: "1px solid rgb(0, 0, 0, 0.25)",
                                    borderRadius: "5px",
                                    alignItems: "left",
                                    backgroundColor: "#ffffff",
                                }}
                                value={voucherCode}
                                // size="large"
                                placeholder='Enter Voucher Code'
                                onChange={(e) => {
                                    if (!isNaN(e.target.value) && e.target.value.length <= 12)
                                        setVoucherCode(e.target.value);
                                }}
                            // suffix={<Icon type='search' />}
                            />
                        </div>
                    </Row>
                }
            </Modal>
        </Row>
    );
};

export default CustomerDetail;
